var map = {
	"./InternetExplorerIcon.png": 7135,
	"./arrowRightIcon.png": 7609,
	"./arrowRightInvertedIcon.png": 5517,
	"./calculatorIcon.png": 4700,
	"./cd.png": 9561,
	"./checkersIcon.png": 6627,
	"./chessIcon.png": 1178,
	"./close.png": 4856,
	"./computerBig.png": 7888,
	"./computerSmall.png": 3461,
	"./credits.png": 3157,
	"./diaryIcon.png": 3539,
	"./documentsIcon.png": 5244,
	"./doomIcon.png": 7937,
	"./dosIcon.png": 290,
	"./findIcon.png": 3706,
	"./folder.png": 5720,
	"./folderIcon.png": 288,
	"./forward.png": 9455,
	"./fourIcon.png": 5968,
	"./genSettingsIcon.png": 2124,
	"./hangmanIcon.png": 5766,
	"./helpIcon.png": 156,
	"./hockeyIcon.png": 6110,
	"./lanIcon.png": 4983,
	"./maximize.png": 8104,
	"./memoryIcon.png": 1532,
	"./minimize.png": 2253,
	"./msnIcon.png": 7898,
	"./myComputer.png": 8951,
	"./paintIcon.png": 3128,
	"./pause.png": 9908,
	"./play.png": 5028,
	"./pongIcon.png": 8057,
	"./programIcon.png": 7173,
	"./recycleBinDocIcon.png": 7577,
	"./recycleBinFullIcon(old).png": 5691,
	"./recycleBinFullIcon.png": 9416,
	"./recycleBinIcon.png": 299,
	"./recycleBinTextIcon.png": 1201,
	"./rewind.png": 6551,
	"./rockPaperScissorsIcon.png": 6601,
	"./runIcon.png": 8626,
	"./scrabbleIcon.png": 7980,
	"./setting.png": 7855,
	"./showcaseIcon.png": 5205,
	"./snakeIcon.png": 8642,
	"./sudokuIcon.png": 1770,
	"./tetrisIcon.png": 8909,
	"./textFileIcon.png": 5870,
	"./tictactoeIcon.png": 7153,
	"./trailIcon.png": 3418,
	"./twentyIcon.png": 2700,
	"./volumeOff.png": 4149,
	"./volumeOn.png": 5056,
	"./whackIcon.png": 6039,
	"./windowExplorerIcon.png": 1569,
	"./windowGameIcon.png": 5756,
	"./windowResize.png": 7188,
	"./windowsStartIcon.png": 8898,
	"./wordleIcon.png": 9366,
	"./wordleIconold.png": 9328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;